/**
 * Inneklima metrics strip from Airon.html design.
 */
export function ClimateStrip() {
  return (
    <div className="climate" id="inneklima">
      <div>
        <h3>Hvorfor godt inneklima faktisk er verdt pengene.</h3>
        <p>
          Dårlig luft er usynlig — men kroppen merker det. Bedre ventilasjon gir lavere sykefravær,
          skarpere konsentrasjon og mindre belastning på bygget. Vi dokumenterer effekten med målinger
          før og etter.
        </p>
      </div>
      <div className="climate-metrics">
        <div className="metric">
          <div className="k">Konsentrasjon ↑</div>
          <div className="v">
            +23<span className="u">%</span>
          </div>
          <div className="g">
            <span style={{ width: "78%" }} />
          </div>
        </div>
        <div className="metric">
          <div className="k">Sykefravær ↓</div>
          <div className="v">
            −35<span className="u">%</span>
          </div>
          <div className="g">
            <span style={{ width: "65%" }} />
          </div>
        </div>
        <div className="metric">
          <div className="k">Energibruk ↓</div>
          <div className="v">
            −40<span className="u">%</span>
          </div>
          <div className="g">
            <span style={{ width: "80%" }} />
          </div>
        </div>
        <div className="metric">
          <div className="k">Levetid bygg ↑</div>
          <div className="v">
            +15<span className="u">år</span>
          </div>
          <div className="g">
            <span style={{ width: "60%" }} />
          </div>
        </div>
      </div>
    </div>
  );
}
